module.exports = __webpack_public_path__ + "static/img/hrzsgxc.08b37ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hrzsgxc.jpg
// module id = /lWt
// module chunks = 1